import React from "react";
import { Link } from "react-router";
import ReactDataSheet from "react-datasheet";
import FirebaseApi from "../../api/firebase";
import Contract from "./Contract";
import "react-table/react-table.css";
import ReactTable from "react-table";
import matchSorter from "match-sorter";
import moment from "moment";
import { connect } from "react-redux";
import SweetAlert from "sweetalert-react";
import "sweetalert/dist/sweetalert.css";
import { renderToStaticMarkup } from "react-dom/server";
import toastr from "toastr";
import Select from "react-select";

class ContractListPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contracts: [],
      loading: true,
      show: false,
      deleting_id: "",
      year_lookback: 2026,
    };
  }

  processContract = (contractInfo, key) => {
    if (contractInfo.name == "Carolina Gutiérrez ") {
      //console.log(contractInfo)
    }

    let date = contractInfo.signing_date.split("-");
    let processedContract = {
      name: contractInfo.name,
      school: contractInfo.selectedOption.label
        ? contractInfo.selectedOption.label
        : null,
      signing_date: date[2] + "-" + date[1] + "-" + date[0],
      //signing_date: contractInfo.signing_date,
      id: key,
      last_modification: contractInfo.last_modification,
      signed: contractInfo.signed,
      startDate: contractInfo.startDate,
      teacher_key: contractInfo.teacher_key,
    };
    return processedContract;
  };

  componentDidMount = () => {
    this.updateContracts();
    //this.modifyKey()
    //this.createNewContractObject()
  };

  createNewContractObject = () => {
    FirebaseApi.GetValues("/contracts").then((snap) => {
      let contractsObj = snap.val();
      if (contractsObj) {
        Object.keys(contractsObj).forEach((key) => {
          let p_contract = this.processContract(contractsObj[key], key);
          FirebaseApi.databaseSet("/contracts_summary/" + key, p_contract);
        });
      }
      this.setState({ loading: false });
    });
  };

  modifyKey = () => {
    FirebaseApi.GetValues("/contracts").then((snap) => {
      let contractsObj = snap.val();
      if (contractsObj) {
        Object.keys(contractsObj).forEach((key) => {
          //console.log(key)
          let date = contractsObj[key]["signing_date"].split("-");
          //console.log(date[2]+'-'+date[1]+'-'+date[0])
          FirebaseApi.databaseSet(
            "/contracts/" + key + "/" + "signing_date",
            date[2] + "-" + date[1] + "-" + date[0]
          );
        });
      }
      //this.setState({contracts, loading: false})
    });
  };

  updateContracts = () => {
    let contracts = [];
    let filtering_date = this.state.year_lookback + "-01-01";
    console.log(filtering_date);
    FirebaseApi.GetValuesWithDateFilter(
      "/contracts_summary",
      "signing_date",
      filtering_date
    ).then((snap) => {
      let contractsObj = snap.val();
      console.log(contractsObj);
      if (contractsObj) {
        Object.keys(contractsObj).forEach((key) => {
          //console.log('adding')
          //contracts.push(this.processContract(contractsObj[key], key))
          contracts.push(contractsObj[key]);
        });
      }
      this.setState({ contracts, loading: false });
    });
  };

  editContract = (contract_id) => {
    FirebaseApi.GetValueByKeyOnce("contracts", contract_id.value).then(
      (snap) => {
        let res = snap.val();
        if (res) {
          let contract = {
            ...res[Object.keys(res)[0]],
            id: Object.keys(res)[0],
          };
          //let date = contract.signing_date.split('-')
          //contract.signing_date = date[2]+'-'+date[1]+'-'+date[0]
          this.props.setContractInfoState(contract);

          FirebaseApi.GetValueByKeyOnce("teachers", contract.teacher_key).then(
            (snap) => {
              let res2 = snap.val();
              if (res2) {
                //let teacher = res2[Object.keys(res2)[0]]
                let teacher = {
                  ...res2[Object.keys(res2)[0]],
                  id: Object.keys(res2)[0],
                };
                //console.log(teacher)
                this.props.setCurrentTeacher(teacher);

                this.props.history.push("/home");
              } else {
                console.log("Anexo no tiene profesor asignado");
              }
            }
          );
        }
      }
    );
  };

  confirmDeleteContract = (contract_id) => {
    this.setState({ show: true, deleting_id: contract_id.value });
  };

  sanitizeRut = (rut) => {
    let clean_rut = rut.split(".").join("");
    let number_rut = clean_rut.split("-")[0];
    let verification_digit = clean_rut.split("-")[1];
    let sanitized_rut_number = parseInt(number_rut).toString();
    let sanitized_rut = sanitized_rut_number + "-" + verification_digit;
    return sanitized_rut;
  };

  deleteContract = () => {
    console.log("Deleting id: " + this.state.deleting_id);
    this.setState({ loading: true });
    FirebaseApi.GetValueByKeyOnce("contracts", this.state.deleting_id).then(
      (snap) => {
        let res = snap.val();
        if (res) {
          let contract = {
            ...res[Object.keys(res)[0]],
            id: Object.keys(res)[0],
          };
          let teacher_key = contract.teacher_key;
          FirebaseApi.GetValueByKeyOnce("teachers", teacher_key).then(
            (snap) => {
              let res = snap.val();
              let res_keys = Object.keys(res);
              let teacher = null;
              res_keys.length > 0 ? (teacher = res[res_keys[0]]) : null;
              console.log(res);
              let school_teacher =
                teacher["contracts"][contract.selectedOption.label];
              console.log(school_teacher);

              if (
                Object.keys(school_teacher).includes(this.state.deleting_id)
              ) {
                console.log("deleting");
                FirebaseApi.RemoveChildByKey(
                  "teachers/" +
                    teacher_key +
                    "/contracts/" +
                    contract.selectedOption.label,
                  this.state.deleting_id
                ).then((err) => {
                  FirebaseApi.RemoveChildByKey(
                    "/contracts",
                    this.state.deleting_id
                  ).then((error) => {
                    FirebaseApi.RemoveChildByKey(
                      "/contracts_summary_2",
                      this.state.deleting_id
                    ).then((error) => {
                      this.setState({ show: false });
                      this.updateContracts();
                    });
                  });
                });
              }
            }
          );
        }
      }
    );
  };

  cancelDeleteContract = () => {
    this.setState({ show: false });
  };

  signContract = (val) => {
    this.setState({ loading: true });
    FirebaseApi.GetValueByKeyOnce("/contracts", val.value).then((snap) => {
      let res = snap.val();
      if (res) {
        let signed = !res[Object.keys(res)[0]].signed;
        console.log(signed);
        let contract = {
          ...res[Object.keys(res)[0]],
          id: Object.keys(res)[0],
          signed: signed,
        };
        FirebaseApi.databaseSet("/contracts/" + contract.id, {
          ...contract,
          last_modification: FirebaseApi.serverTimestamp(),
        }).then(() => {
          let succes_message = "Anexo actualizado";
          toastr.success(succes_message);
          this.updateContracts();
        });
      }
    });
  };

  generate = (contract_id) => {
    FirebaseApi.GetValueByKeyOnce("contracts", contract_id.value).then(
      (snap) => {
        let res = snap.val();
        if (res) {
          let contract = {
            ...res[Object.keys(res)[0]],
            id: Object.keys(res)[0],
          };
          this.props.setContractInfoState(contract);
          this.props.history.push("/protected");
        }
      }
    );
  };

  handleYearChange = (selectedOption) => {
    this.setState(
      { year_lookback: selectedOption.value, loading: true },
      () => {
        this.updateContracts();
      }
    );
  };

  generateYearDropdownOptions = () => {
    let ret = [];

    for (let i = new Date().getFullYear(); i > 2017; i--) {
      ret.push({ value: i, label: i });
    }

    return ret;
  };

  render() {
    return (
      <div className="jumbotron">
        <div className="flex">
          <h1>Contratos</h1>
          <div
            className="title-spinner"
            style={
              this.state.loading ? { display: "flex" } : { display: "none" }
            }
          >
            <i
              className="fas fa-circle-notch fa-spin fa-2x"
              aria-hidden="true"
            ></i>
          </div>
        </div>
        <SweetAlert
          show={this.state.show}
          title="Confirmar"
          text={renderToStaticMarkup(<h5>¿Eliminar el anexo?</h5>)}
          html
          onConfirm={() => this.deleteContract()}
          onCancel={() => this.cancelDeleteContract()}
          confirmButtonText="Eliminar"
          cancelButtonText="Cancelar"
          showCancelButton
        />
        <div className="form-group w-25">
          <label htmlFor="schedule-type">Sacar anexos desde año:</label>
          <Select
            id="year_lookback"
            name="year_lookback"
            value={this.state.year_lookback}
            onChange={this.handleYearChange}
            options={this.generateYearDropdownOptions()}
            placeholder="Seleccionar año "
          />
        </div>
        <ReactTable
          data={this.state.contracts}
          filterable
          columns={[
            {
              Header: "Nombre",
              accessor: "name",
              id: "name",
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["name"] }),
              filterAll: true,
            },

            {
              Header: "Colegio",
              accessor: "school",
              id: "school",
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["school"] }),
              filterAll: true,
            },
            {
              Header: "Valor Hora",
              accessor: "startDate",
              id: "startDate",
              Cell: ({ value }) => value,
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["startDate"] }),
              filterAll: true,
            },

            {
              Header: "Fecha de Firma Anexo",
              accessor: "signing_date",
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["signing_date"] }),
              filterAll: true,
              sortMethod: (a, b) => {
                let momentA = moment(a, "DD-MM-YYYY");
                let momentB = moment(b, "DD-MM-YYYY");

                return momentA.isSameOrBefore(momentB) ? 1 : -1;
              },
            },
            {
              Header: "Firmado",
              accessor: "signed",
              Cell: ({ value }) => (value ? "Si" : "No"),
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["signed"] }),
              filterMethod: (filter, row) => {
                if (filter.value === "all") {
                  return true;
                }
                if (filter.value === "signed") {
                  return row[filter.id];
                }

                if (filter.value === "not_signed") {
                  return !row[filter.id];
                }
              },
              Filter: ({ filter, onChange }) => (
                <select
                  onChange={(event) => onChange(event.target.value)}
                  style={{ width: "100%" }}
                  value={filter ? filter.value : "all"}
                >
                  <option value="all">Todos</option>
                  <option value="signed">Firmados</option>
                  <option value="not_signed">No firmados</option>
                </select>
              ),
            },
            {
              Header: "Última modificación",
              accessor: "last_modification",
              Cell: ({ value }) => moment(value).format("DD-MM-YYYY, h:mm a"),
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, {
                  keys: ["last_modification"],
                }),
              filterAll: true,
              sortMethod: (a, b) => {
                let momentA = moment(a);
                let momentB = moment(b);
                return momentA.isSameOrBefore(momentB) ? 1 : -1;
              },
            },
            {
              Header: "",
              accessor: "id",
              Cell: (value) => (
                <div className="centered-text flex space-around">
                  <div>
                    <button
                      className="btn btn-primary"
                      onClick={() => this.editContract(value)}
                    >
                      <i className="far fa-edit"></i>
                    </button>
                  </div>
                  <div>
                    <button
                      className="btn btn-warning"
                      onClick={() => this.signContract(value)}
                    >
                      <i className="far fa-clipboard"></i>
                    </button>
                  </div>
                  <div>
                    <button
                      className="btn btn-success"
                      onClick={() => this.generate(value)}
                    >
                      <i className="fas fa-file-pdf"></i>
                    </button>
                  </div>
                  <div>
                    <button
                      className="btn btn-danger"
                      onClick={() => this.confirmDeleteContract(value)}
                    >
                      <i className="far fa-trash-alt" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              ),
              Filter: () => "",
            },
          ]}
          defaultPageSize={10}
          className="-striped -highlight"
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setContractInfoState: (contractInfo) => {
      dispatch({
        type: "SET CONTRACT INFO",
        contractInfo: contractInfo,
      });
    },
    setCurrentTeacher: (teacherInfo) => {
      dispatch({
        type: "SET TEACHER INFO",
        teacherInfo: teacherInfo,
      });
    },
  };
}

export default connect(null, mapDispatchToProps)(ContractListPage);



// WEBPACK FOOTER //
// ./src/components/list/List.js